export default function CsMappingPortScanning() {
  return (
    <h2>Cs Mapping Port Scanning</h2>
  );
}
